import {
  ComponentDecorator,
  FormikProps,
  withFormik,
  FormikBag,
  FormikErrors,
  validateYupSchema,
  yupToFormErrors,
  getIn,
  FormikValues
} from "formik";
import Yup from "yup";
import { UiError } from "../types";
import { voegApiFoutToe } from "../helpers";

/* istanbul ignore next */
const noop = (): void => {};

export type WithAdviesBoxFormikConfig<OuterProps, FormikValues> = {
  handleSubmit?: (values: FormikValues, formikBag: FormikBag<OuterProps, FormikValues>) => void;
  mapPropsToValues: (props: OuterProps) => FormikValues;
  validationSchema: Yup.ObjectSchema<any> | ((props: OuterProps) => Yup.ObjectSchema<any>);
  createValidationContext?: (props: OuterProps, values: FormikValues) => any;
  mapPropsToErrors?: (props: OuterProps) => FormikErrors<FormikValues>;
  enableReinitialize?: boolean | undefined;
};

export function withAdviesboxFormik<Props extends object, Values extends ((props: Props) => FormikValues) | undefined>({
  handleSubmit = noop,
  mapPropsToValues,
  validationSchema,
  createValidationContext,
  mapPropsToErrors,
  enableReinitialize
}: WithAdviesBoxFormikConfig<Props, FormikValues>): ComponentDecorator<Props, Props & FormikProps<FormikValues>> {
  return withFormik<Props, FormikValues>({
    mapPropsToValues,
    handleSubmit,
    enableReinitialize,
    validateOnChange: false,
    validate: async (values, props): Promise<FormikErrors<Values> | object> => {
      const platformApiFouten: UiError[] | null = getIn(values, "platformApiFouten");

      try {
        if (typeof validationSchema === "function") {
          validationSchema = validationSchema(props);
        }

        const context = typeof createValidationContext === "function" ? createValidationContext(props, values) : {};

        await validateYupSchema(values, validationSchema, true, context);
      } catch (yupErrors) {
        const formikErrors = voegApiFoutToe(yupToFormErrors(yupErrors), platformApiFouten);

        return formikErrors;
      }

      return voegApiFoutToe({}, platformApiFouten);
    },
    mapPropsToErrors
  });
}
